import useRestockLogsTable from "./useWaybillsTable";
import secondaryComponents from "..";
import Orderflows from "../StoreCheckout/Orderflows";
import { Link } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";

const WaybillsTable = ({
  metaDetails,
  waybills,
  handleFetchWaybills,
  gotoPage,
}) => {
  const { instance, selectedOrder, setSelectedOrder } = useRestockLogsTable({
    waybills,
    handleFetchWaybills,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="py-5">
          <h4 className="text-center">You have no generated waybill</h4>
          <p className="text-center">
            Generate waybills from your{" "}
            <Link
              to={pathConstants.INVENTORY_SALES_TRANSACTIONS}
              className="purple--text"
            >
              sales transaction
            </Link>{" "}
            records When you do, they would appear here
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {waybills?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={selectedOrder !== null}
        closeModal={() => setSelectedOrder(null)}
        width={1300}
        padding={0}
        style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      >
        <Orderflows
          closeModal={() => setSelectedOrder(null)}
          orderId={selectedOrder}
          defaultLanding={"tnxReceipt"}
          viaSaleRecord={true}
        />
      </secondaryComponents.Modal>
    </>
  );
};

export default WaybillsTable;
